import { useMutation } from "react-query";
import { useAccessToken } from "hooks/useAccessToken";
import mutationFn from "ApiLayer/Utility/submitUtilityData";
import { showMutationAlert } from "utils/helpers";
import useAlert from "hooks/useAlert";
import { useResetRecommendedBMCRPQueries } from "hooks/useResetRecommendedBMCRPQueries";

export const useSubmitUtilityData = (buildingModelUid: string, onSuccess: () => void, onError: () => void) => {
    const accessToken = useAccessToken();
    const alert = useAlert();
    const resetRecommendedBMCRPQueries = useResetRecommendedBMCRPQueries(buildingModelUid);

    return useMutation({
        mutationFn: async (utilityData: UtilityData[]) => mutationFn(accessToken, buildingModelUid, utilityData),
        onSuccess: () => {
            onSuccess();
            alert.success("Energy data added.");
            resetRecommendedBMCRPQueries();
        },
        onError: (errors) => {
            onError();
            showMutationAlert(errors, alert);
        },
    });
};
